/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_2_TitleInputs */

const et_portfolio_project_2_title = /** @type {(inputs: Portfolio_Project_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hüljatud projektist tulu tootva brändini 90 päevaga.`)
};

const en_portfolio_project_2_title = /** @type {(inputs: Portfolio_Project_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turned an abandoned project into a revenue-generating brand in 90 days.`)
};

/**
* | output |
* | --- |
* | "Turned an abandoned project into a revenue-generating brand in 90 days." |
*
* @param {Portfolio_Project_2_TitleInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_2_title = /** @type {((inputs?: Portfolio_Project_2_TitleInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_2_TitleInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_2_title(inputs)
	return en_portfolio_project_2_title(inputs)
});